import Search from "./containers/Search";

export default Search;
